/**
 * The merge wizard's search params. `primary_id` / `secondary_id` are the pair
 * being merged (internal ids), written by the page as people are selected.
 * The rest arrive on inbound links and are read once: `source` attributes the
 * page view; `email` / `filters` are the list search the person came from.
 */
export type PeopleMergeSearch = {
  primary_id?: string;
  secondary_id?: string;
  source?: string;
  email?: string;
  filters?: string;
};

/**
 * Ids and search terms are strings, but the router JSON-parses search values,
 * so a numeric-looking id arrives as a number; take its string form. Anything
 * else is not one of ours and stays absent.
 */
function stringParam(value: unknown): string | undefined {
  if (typeof value === 'string') return value;
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return undefined;
}

/**
 * `validateSearch` replaces this route's search, so the incoming params are
 * spread to preserve global ones the page doesn't own (masq_account_id, …) and
 * only the ones it does are narrowed.
 */
// oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
export function validateMergeSearch(search: Record<string, unknown>): Record<string, unknown> & PeopleMergeSearch {
  return {
    ...search,
    primary_id: stringParam(search.primary_id),
    secondary_id: stringParam(search.secondary_id),
    source: stringParam(search.source),
    email: stringParam(search.email),
    filters: stringParam(search.filters),
  };
}
